import { Component, inject, signal, effect } from '@angular/core';
import { LayoutShellComponent, UserInfo } from '@olonera/layout';
import { NavigationConfigService } from '@olonera/layout';
import { AuthService } from '@olonera/auth';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-authenticated-layout',
  standalone: true,
  imports: [LayoutShellComponent],
  template: `
    <lib-layout-shell
      [navSections]="navSections"
      [pageTitle]="pageTitle()"
      [pageSubtitle]="pageSubtitle()"
      [user]="user()"
      userSubtitle="Platform Administrator"
      role="Administrator"
      [darkSidebar]="true"
      (logout)="onLogout()"
      (settingsClick)="onSettingsClick()"
      (profileClick)="onProfileClick()"
      (notificationClick)="onNotificationClick()"
    >
    </lib-layout-shell>
  `,
  styles: [`
    :host {
      display: block;
      height: 100vh;
    }
  `]
})
export class AuthenticatedLayoutComponent {
  private readonly authService = inject(AuthService);
  private readonly navConfig = inject(NavigationConfigService);
  private readonly router = inject(Router);

  user = signal<UserInfo | null>(null);
  pageTitle = signal('');
  pageSubtitle = signal('');
  navSections = this.navConfig.getAdminNav();
  private lastSyncedUserId: string | null = null;

  constructor() {
    // Initial check
    this.updateTitles(this.router.url);

    // Subscribe to future routing events
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.updateTitles(event.urlAfterRedirects || event.url);
    });

    effect(() => {
      const userDto = this.authService.currentUser();
      if (userDto) {
        if (userDto.id !== this.lastSyncedUserId) {
          this.lastSyncedUserId = userDto.id;
        }

        this.user.set({
          firstName: userDto.firstName,
          lastName: userDto.lastName,
          email: userDto.email,
        });
      }
    });
  }

  onLogout(): void {
    this.authService.logout();
  }

  onSettingsClick(): void {
    this.router.navigate(['/settings']);
  }

  onProfileClick(): void {
    this.router.navigate(['/settings']);
  }

  onNotificationClick(): void {
    // Handle notification click
  }

  private updateTitles(url: string): void {
    if (url.includes('/dashboard')) {
      this.pageTitle.set('');
      this.pageSubtitle.set('');
    } else if (url.includes('/messages')) {
      this.pageTitle.set('Messages');
      this.pageSubtitle.set('Member conversation threads');
    } else if (url.includes('/specialists')) {
      this.pageTitle.set('');
      this.pageSubtitle.set('');
    } else if (url.includes('/resources')) {
      this.pageTitle.set('');
      this.pageSubtitle.set('');
    } else if (url.includes('/protocol-templates')) {
      this.pageTitle.set('Plan Templates');
      this.pageSubtitle.set('Review and publish templates to WooCommerce');
    } else if (url.includes('/settings')) {
      this.pageTitle.set('');
      this.pageSubtitle.set('');
    } else if (url.includes('/logs')) {
      this.pageTitle.set('');
      this.pageSubtitle.set('');
    } else {
      this.pageTitle.set('Admin Console');
      this.pageSubtitle.set('Overview');
    }
  }
}
